module.exports = __webpack_public_path__ + "static/media/guide_img1_6.3261c1b5.png";